<template>
  <div>
    <v-btn icon @click="isUp = !isUp">
      <v-icon>{{ isUp ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'UpDownChevron',
  props: {
    flg: { default: false }
  },
  data: () => {
    return { isUp: false }
  },
  created() {
    // 親から受け取ったデータを初期値に設定する
    this.isUp = this.flg
  },
  watch: {
    flg: function (newVal, oldVal) {
      this.isUp = newVal
    }
  }
}
</script>
